export const AUTH_TOKEN = 'auth-token'
export const USER_ID = 'user-id'
export const USER_FIRST_NAME = 'user-first-name'
export const USER_LAST_NAME = 'user-last-name'
export const USER_IS_ADMIN = 'user-is-admin'
export const USER_IS_STAFF = 'user-is-staff'
export const USER_SLUG = 'user-slug'
export const USER_AVATAR = 'user-avatar'
export const USER_COMPANY_ID = 'user-company-id'
